export const toSentenceCase = (str, exceptions = []) => {
  if (!str || typeof str !== "string") return "";

  let formatted = str.trim().toLowerCase();

  formatted = formatted.charAt(0).toUpperCase() + formatted.slice(1);

  exceptions.forEach((ex) => {
    const regex = new RegExp(`\\b${ex.toLowerCase()}\\b`, "gi");
    formatted = formatted.replace(regex, ex);
  });

  return formatted;
};

export const formatKey = (key) => {
  return key
    .replace(/_/g, " ")          // quita guiones bajos
    .toLowerCase()               // pasa todo a minúsculas
    .replace(/\b\w/g, l => l.toUpperCase()); // capitaliza cada palabra
}


